import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild, OnDestroy } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { SafeUrl } from "@angular/platform-browser";
import { ServiceAppService } from "./../../security/service-app.service";
import { NOME_MARCA } from "././../../../environments/environment";
import { MenuItem } from 'primeng/api';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: "app-navegacao",
  templateUrl: "./navegacao.component.html",
  styleUrls: ["./navegacao.component.scss"],
})
export class NavegacaoComponent implements OnInit, OnDestroy {
  @Output() changeLanguage: EventEmitter<any> = new EventEmitter<any>();
  @Output() sidebarToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() habilitar: boolean;

  items: MenuItem[];
  imageUrl: SafeUrl;
  srcBandeira = "assets/img/us.png";
  ocultaMenu: boolean = true;
  ocultaMenuGWM: boolean = true;
  ocultaMenuGeral: boolean = true;
  _menu: any[] = [];
  _exibirMenu = false;
  versaoPortal: string;
  state: string = "default";
  
  // Controle do estado do sidebar
  sidebarActive: boolean = false;
  
  @ViewChild('sidebar', { static: false }) sidebarRef: ElementRef;
  submenuState: { [state: string]: string } = {
    RMPV: "default",
    PCA: "default",
    relatorioVeiculos: "default",
    businessIntelligence: "default",
    commercial: "default",
    estoque: "default",
    parametros: "default",
    acessos: "default",
    montadora: "default",
  };

  qtdClick = 0;
  qtdClickMenu = 0;
  retorno: any;

  private resizeListener: () => void;
  private routerSubscription: any;

  constructor(
    private toast: ToastrService, 
    private service: ServiceAppService,
    private router: Router
  ) { }

  ngOnInit() {
    this.service.getDados(`/admin/capturarMarca`).subscribe(res => {
      const logo = res.nome;
      if (logo.includes("TRIUMPH")) {
        this.srcBandeira = "assets/img/gb.png";
      }
    });

    this.chamarMenu(1);
    this.service
      .getImagem(`/alterar_imagem/getImagem?tipoImagem=2`)
      .subscribe((response) => {
        const base64Image = response.image;
        this.imageUrl = `data:image/jpeg;base64,${base64Image}`;
      });

    this.service.getDados("/versao").subscribe((dados) => {
      this.versaoPortal = `Versão: ${dados.versao_modulo}`;
    });

    const userRole = this.service.getUserRole();
    if (userRole === "admin") {
      this.ocultaMenuGeral = true;
    } else {
      this.ocultaMenuGeral = false;
    }

    const permissaoUsuario = JSON.parse(sessionStorage.getItem('currentUser')).username;
    if (permissaoUsuario === "admin") {
      this.habilitar = true;
    } else {
      this.habilitar = false;
    }
    
    // Aplicar estilos mobile inicialmente
    setTimeout(() => {
      this.applyMobileStyles();
    }, 100);
    
    // Listener para mudanças de tamanho da tela
    this.resizeListener = () => {
      this.applyMobileStyles();
    };
    window.addEventListener('resize', this.resizeListener);
    
    // Listener para mudanças de rota - fechar menu mobile quando mudar de página
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        // Se estiver em mobile e o menu estiver aberto, fechar
        if (this.isMobile() && this.sidebarActive) {
          this.closeSidebar();
        }
      });
  }

  ngOnDestroy() {
    // Limpar listener de resize
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
    
    // Limpar subscription do router
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  @Input("menu")
  set menu(value: any[]) {
    this._menu = value;
    this._exibirMenu = this._menu.length > 2;
  }

  getMostrarMenu(): boolean {
    return this._exibirMenu;
  }

  switchLanguage(language: string) {
    if (language == 'br') {
      this.chamarMenu(1);
    } else {
      this.chamarMenu(2);
    }
    sessionStorage.setItem("language", JSON.stringify(language));
    this.changeLanguage.emit(language);
  }

  msgPagina() {
    this.qtdClick++;
    let aleatorio = crypto.getRandomValues(new Uint32Array(1))[0] % 7;

    if (this.qtdClick >= 2 && this.qtdClick < aleatorio) {
      this.toast.warning("Nada aqui", "Aviso", {
        closeButton: true,
      });
    }

    if (this.qtdClick >= 5) {
      document
        .getElementById("button")
        .setAttribute("data-target", "#meuModal");
      if (this.qtdClick > aleatorio) {
        document.getElementById("button").setAttribute("data-target", "");
        return (this.qtdClick = 0);
      }
    }
  }

  verificaNavegacao(rota) {
    return true;
  }

  toggleSidebar() {
    this.sidebarActive = !this.sidebarActive;
    this.updateSidebarClasses();
    
    // Emitir evento para componente pai
    this.sidebarToggle.emit(this.sidebarActive);
  }

  // Método para verificar se está em mobile
  isMobile(): boolean {
    return window.innerWidth <= 1024;
  }

  // Método para fechar menu quando item for clicado (apenas em mobile)
  onMenuItemClick(event: any) {
    // Verificar se o clique foi em um link de navegação real
    const target = event.target as HTMLElement;
    const linkElement = target.closest('a[routerLink]') || target.closest('a[href]');
    
    // Só fechar o menu se estiver em mobile E se clicou em um link de navegação
    if (this.isMobile() && this.sidebarActive && linkElement) {
      // Verificar se não é um clique para expandir/colapsar submenu
      const isSubmenuToggle = target.closest('.p-panelmenu-icon') || 
                             target.closest('.p-panelmenu-header') ||
                             target.closest('.p-menuitem-link');
      
      // Só fechar se não for um toggle de submenu
      if (!isSubmenuToggle) {
        this.closeSidebar();
      }
    }
  }

  // Método específico para links de navegação que sempre fecham o menu em mobile
  onNavigationLinkClick(event: any) {
    // Sempre fechar o menu em mobile quando clicar em links de navegação
    if (this.isMobile() && this.sidebarActive) {
      this.closeSidebar();
    }
  }

  // Método para lidar com cliques no p-panelMenu
  onPanelMenuClick(event: any) {
    // Verificar se o clique foi em um link de navegação real
    const target = event.target as HTMLElement;
    
    // Verificar se é um clique para expandir/colapsar submenu
    const isSubmenuToggle = target.closest('.p-panelmenu-icon') || 
                           target.closest('.p-panelmenu-header') ||
                           target.closest('.p-menuitem-link');
    
    // Verificar se é um link de navegação real
    const isNavigationLink = target.closest('a[routerLink]') || 
                            target.closest('a[href]') ||
                            target.closest('.p-menuitem-link[routerLink]');
    
    // Só fechar o menu se estiver em mobile E se clicou em um link de navegação real
    if (this.isMobile() && this.sidebarActive && isNavigationLink && !isSubmenuToggle) {
      this.closeSidebar();
    }
  }

  private updateSidebarClasses() {
    // O sidebar agora é controlado pelo template binding
    // Só precisamos atualizar o content
    const content = document.getElementById('content');
    
    if (content) {
      if (this.sidebarActive) {
        content.classList.remove('content-inactive');
        content.classList.add('active');
      } else {
        content.classList.remove('active');
        content.classList.add('content-inactive');
      }
    }
    
    // Aplicar estilos diretamente via JavaScript para garantir posicionamento correto em mobile
    this.applyMobileStyles();
  }

  private applyMobileStyles() {
    // Verificar se está em mobile
    if (this.isMobile()) {
      const sidebar = document.getElementById('sidebar');
      if (sidebar) {
        // Aplicar estilos diretamente via JavaScript
        sidebar.style.margin = '0';
        sidebar.style.marginLeft = '0';
        sidebar.style.position = 'fixed';
        sidebar.style.top = '0';
        sidebar.style.left = '0';
        sidebar.style.width = '100vw';
        sidebar.style.height = '100vh';
        sidebar.style.minWidth = '100vw';
        sidebar.style.maxWidth = '100vw';
        sidebar.style.zIndex = '999999';
        sidebar.style.background = '#000000';
        sidebar.style.color = '#ffffff';
        sidebar.style.display = 'flex';
        sidebar.style.flexDirection = 'column';
        sidebar.style.justifyContent = 'space-between';
        sidebar.style.alignItems = 'stretch';
        sidebar.style.boxSizing = 'border-box';
        sidebar.style.border = 'none';
        sidebar.style.outline = 'none';
        sidebar.style.padding = '0';
        sidebar.style.overflowY = 'auto';
        sidebar.style.overflowX = 'hidden';
        sidebar.style.float = 'none';
        sidebar.style.clear = 'both';
        
        if (this.sidebarActive) {
          sidebar.style.opacity = '1';
          sidebar.style.visibility = 'visible';
          sidebar.style.pointerEvents = 'auto';
          
          // Garantir que todos os elementos internos sejam clicáveis
          const internalElements = sidebar.querySelectorAll('.sidebar-header, .scroll, .footer, .d-flex, ul, li, a, button, i');
          internalElements.forEach((element: HTMLElement) => {
            element.style.pointerEvents = 'auto';
          });
        } else {
          sidebar.style.opacity = '0';
          sidebar.style.visibility = 'hidden';
          sidebar.style.pointerEvents = 'none';
        }
      }
    } else {
      // Desktop - restaurar estilos originais
      const sidebar = document.getElementById('sidebar');
      if (sidebar) {
        // Remover estilos inline que podem estar interferindo
        sidebar.style.removeProperty('margin');
        sidebar.style.removeProperty('margin-left');
        sidebar.style.removeProperty('position');
        sidebar.style.removeProperty('top');
        sidebar.style.removeProperty('left');
        sidebar.style.removeProperty('width');
        sidebar.style.removeProperty('height');
        sidebar.style.removeProperty('min-width');
        sidebar.style.removeProperty('max-width');
        sidebar.style.removeProperty('z-index');
        sidebar.style.removeProperty('background');
        sidebar.style.removeProperty('color');
        sidebar.style.removeProperty('display');
        sidebar.style.removeProperty('flex-direction');
        sidebar.style.removeProperty('justify-content');
        sidebar.style.removeProperty('align-items');
        sidebar.style.removeProperty('box-sizing');
        sidebar.style.removeProperty('border');
        sidebar.style.removeProperty('outline');
        sidebar.style.removeProperty('padding');
        sidebar.style.removeProperty('overflow-y');
        sidebar.style.removeProperty('overflow-x');
        sidebar.style.removeProperty('float');
        sidebar.style.removeProperty('clear');
        sidebar.style.removeProperty('opacity');
        sidebar.style.removeProperty('visibility');
        sidebar.style.removeProperty('pointer-events');
        
        // Garantir que elementos internos não tenham estilos inline
        const internalElements = sidebar.querySelectorAll('.sidebar-header, .scroll, .footer, .d-flex, ul, li, a, button, i');
        internalElements.forEach((element: HTMLElement) => {
          element.style.removeProperty('pointer-events');
        });
      }
    }
  }

  closeSidebar() {
    this.sidebarActive = false;
    this.updateSidebarClasses();
    
    // Emitir evento para componente pai
    this.sidebarToggle.emit(this.sidebarActive);
  }

  // Método público para ser chamado pelo componente pai
  openSidebar() {
    this.sidebarActive = true;
    this.updateSidebarClasses();
    
    // Emitir evento para componente pai
    this.sidebarToggle.emit(this.sidebarActive);
  }

  chamarMenu(idioma: number) {
    this.service.getDados(`/ativacao_menu/listarJson?idioma=${idioma}`).subscribe((response) => {
      this.items = response;
    });
  }

  getNavegacao() {
    const jsonObejct = JSON.parse(sessionStorage.getItem('currentUser'))
    let username = jsonObejct.username;
    let oldToken = jsonObejct.token;
    this.service.getToken(`/admin/renovarToken?authorization=${oldToken}&login=${username}`).subscribe((res) => {
      const retorno = res;
      let newToken = retorno.Authentication.replace(/"'"/g, "");

      sessionStorage.removeItem("currentUser");
      sessionStorage.removeItem("token");
      sessionStorage.setItem(
        "currentUser",
        JSON.stringify({ username: retorno.Username, token: retorno.Authentication })
      );
      sessionStorage.setItem("token", newToken);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    });
  }
}
